module.exports = __webpack_public_path__ + "img/wode_icon_daishouhuo@2x.32807c4d.png";